import * as angular from "angular";

export class DataSetService {
    private readonly apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/dataset";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot);
    }

    inprogress(): Promise<object> {
        return this.$http.get(this.apiRoot + "/inprogress/");
    }

    info(data: object): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/", { params: data });
    }

    anonymize(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/anonymize", data);
    }
}

angular.module("vcServices").service("DataSetService", DataSetService);
